import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: "",
  users: [],
  page: 0,
  has_prev: false,
  total_pages: 0,
  total_result: 0,
}

const deliverySlice = createSlice({
  name: 'getDeliveryUserSlice',
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      return {...state, loading: action.payload, error: ''};
    },

    setSuccess: (state, action) => {
      return {...state, success: true, loading: false, error: ''}

    },
    setDeliveryUsers: (state, action) => {
      return {
        ...state, loading: false,
        has_next: action.payload.has_next,
        has_prev: action.payload.has_prev,
        total_pages: action.payload.total_pages,
        total_result: action.payload.total_result,
        page: action.payload.page,
        users: action.payload.data, error: ''
      };
    },

    getDeliveryUsers: (state, action) => {
    },

    createUser: (state, action) => {
      return{...state, loading: false, success: true}
    },

    setUpdatedUser: (state, action) => {
      return {...state, loading: false, users: [...state.users, action.payload]}
    },

    setStatusUpdatedUser: (state, action) => {
      return {...state, loading: false, users: [...state.users, action.payload]}
    },

    setChangeStatus: (state, action) => {
    },

    setUpdateIndex: (state, action) =>{
      return {
        ...state,
        loading: false,
        users: [...state.users].map((u, index) => {
          if (index === action.payload.index) {
            return { ...u, status: action.payload.status}
          } else {
            return u
          }
        }),
      }
  },

    setError: (state, action) => {
      return {...state, error: action.payload, loading: false};
    }
  }

})

export const {
  setLoading,
  setSuccess,
  getDeliveryUsers,
  setDeliveryUsers,
  setUpdatedUser,
  setChangeStatus,
  createUser,
  setError,
  setUpdateIndex
} = deliverySlice.actions;
export default deliverySlice.reducer;